import jsPDF from 'jspdf';
import 'jspdf-autotable';

export const generatePdfReport = (title, headers, data, filename) => {
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.text(title, 14, 22);

  doc.autoTable({
    startY: 30,
    head: [headers],
    body: data,
    theme: 'striped',
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [48, 63, 159], // Un azul oscuro para el encabezado
      textColor: 255,
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240], // Gris claro para filas alternas
    },
    didDrawPage: function (data) {
      // Footer
      let str = 'Página ' + doc.internal.getNumberOfPages();
      doc.setFontSize(10);
      doc.text(str, data.settings.margin.left, doc.internal.pageSize.height - 10);
    }
  });

  doc.save(`${filename}.pdf`);
};